
import SearchIcon from '../../Icons/SearchIcon.vue'
import HxNFilters from '../../HxNFilters.vue'
import HxNItem from '../../HxNItem.vue'
import LoginRequired from '../../LoginRequired.vue'
import Icon from './Icon.vue'

export default {
    Name: 'HxNViewer',
    Icons: [Icon],
    components: {
        LoginRequired,
        HxNFilters,
        HxNItem,
        SearchIcon
    },
    props: {
        isLogged: {
            type: Boolean,
            required: true
        },
        filters: {
            type: Object,
            required: true
        },
        indexById: {
            type: Object,
            required: true
        },
        selectedFilters: {
            type: Array,
            required: true
        },
        allHighlights: {
            type: Array,
            required: true
        },
        filteredHighlights: {
            type: Array,
            required: true
        },
        toggleSelectedFilter: {
            type: Function,
            required: true
        },
        setHighlight: {
            type: Function,
            required: true
        }
    },
    data () {
        return {
            searchQuery: ''
        }
    },
    computed: {
        searchedHighlights () {
            if (!this.searchQuery.trim()) {
                return this.filteredHighlights
            }

            const query = this.searchQuery.toLowerCase().trim()
            return this.filteredHighlights.filter((highlight) => {
                return highlight.note && highlight.note.toLowerCase().includes(query)
            })
        }
    },
    inject: ['fvAPI_HighlightDelete', 'fvAPI_HighlightUpdate', 'toast'],
    methods: {
        deleteHighlight (selectedHighlight) {
            this.fvAPI_HighlightDelete(selectedHighlight)
                .then(() => {
                    const highlightIndex = this.allHighlights.findIndex(s => s.id === selectedHighlight.id)
                    if (highlightIndex !== -1) {
                        this.$emit('delete-highlight', highlightIndex)
                    }
                    this.$toast.success(this.$t('تم حذف التحديد'))
                })
        },
        updateNote (highlight) {
            this.fvAPI_HighlightUpdate(highlight)
                .then(() => {
                    const highlightIndex = this.allHighlights.findIndex(s => s.id === highlight.id)
                    if (highlightIndex !== -1) {
                        this.$emit('update-highlight', {
                            highlightIndex,
                            highlight
                        })
                    }
                    this.$toast.success(this.$t('تم تعديل الملاحظة'))
                })
        }
    }
}
